import React from 'react';
import Icon from '../../../components/AppIcon';

const IntegrationStatus = ({ integrations, currentLanguage }) => {
  const labels = {
    fr: {
      title: 'État des intégrations',
      connected: 'Connecté',
      disconnected: 'Déconnecté',
      configure: 'Configurer',
      lastSync: 'Dernière sync',
      messagesDelivered: 'Messages livrés',
      deliveryRate: 'Taux de livraison'
    },
    ar: {
      title: 'حالة التكاملات',
      connected: 'متصل',
      disconnected: 'غير متصل',
      configure: 'تكوين',
      lastSync: 'آخر مزامنة',
      messagesDelivered: 'الرسائل المسلمة',
      deliveryRate: 'معدل التسليم'
    }
  };

  const getIntegrationIcon = (type) => {
    const icons = {
      email: 'Mail',
      whatsapp: 'MessageCircle',
      sms: 'Smartphone'
    };
    return icons?.[type] || 'Plug';
  };

  const formatLastSync = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);

    if (diffMins < 1) return currentLanguage === 'fr' ? 'À l\'instant' : 'الآن';
    if (diffMins < 60) return `${diffMins} ${currentLanguage === 'fr' ? 'min' : 'د'}`;
    return `${diffHours} ${currentLanguage === 'fr' ? 'h' : 'س'}`;
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-warm p-4 md:p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Plug" size={20} className="text-primary" />
        </div>
        <h2 className="text-lg md:text-xl font-semibold text-foreground">
          {labels?.[currentLanguage]?.title}
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {integrations?.map((integration) => (
          <div
            key={integration?.id}
            className="border border-border rounded-lg p-4 hover:shadow-warm transition-smooth"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                  integration?.status === 'connected' ? 'bg-success/10' : 'bg-error/10'
                }`}>
                  <Icon 
                    name={getIntegrationIcon(integration?.type)} 
                    size={20} 
                    className={integration?.status === 'connected' ? 'text-success' : 'text-error'}
                  />
                </div>
                <div>
                  <h3 className="font-medium text-foreground">{integration?.name}</h3>
                  <span className={`caption ${
                    integration?.status === 'connected' ? 'text-success' : 'text-error'
                  }`}>
                    {integration?.status === 'connected' 
                      ? labels?.[currentLanguage]?.connected 
                      : labels?.[currentLanguage]?.disconnected}
                  </span>
                </div>
              </div>
            </div>

            {integration?.status === 'connected' && (
              <div className="space-y-3">
                <div className="flex items-center justify-between caption text-muted-foreground">
                  <span>{labels?.[currentLanguage]?.lastSync}</span>
                  <span className="font-medium text-foreground">
                    {formatLastSync(integration?.lastSync)}
                  </span>
                </div>

                <div className="flex items-center justify-between caption text-muted-foreground">
                  <span>{labels?.[currentLanguage]?.messagesDelivered}</span>
                  <span className="font-medium text-foreground">
                    {integration?.messagesDelivered?.toLocaleString()}
                  </span>
                </div>

                <div className="flex items-center justify-between caption text-muted-foreground">
                  <span>{labels?.[currentLanguage]?.deliveryRate}</span>
                  <span className="font-medium text-success">
                    {integration?.deliveryRate}%
                  </span>
                </div>

                <div className="w-full bg-muted rounded-full h-2 mt-2">
                  <div
                    className="bg-success h-2 rounded-full transition-smooth"
                    style={{ width: `${integration?.deliveryRate}%` }}
                  />
                </div>
              </div>
            )}

            {integration?.status === 'disconnected' && (
              <button className="w-full mt-3 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-smooth">
                {labels?.[currentLanguage]?.configure}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntegrationStatus;